var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subtitle.trainImage)?_c('div',{staticClass:"subTitleBox"},[_c('img',{attrs:{"src":_vm.subtitle.trainImage,"alt":_vm.subtitle.title,"title":_vm.subtitle.title}}),_c('span',[_vm._v(_vm._s(_vm.subtitle.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }